import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController, ToastController } from 'ionic-angular';
import { Database } from '../../providers/database';
import { UserData } from '../../providers/user';
import { EventData } from '../../providers/event';
import { AuthData } from '../../providers/auth';
import { Translate } from '../../providers/translate';
import { NetworkProfilePage } from '../network-profile/network-profile';
import * as firebase from 'firebase';

@Component({
  selector: 'page-network-contacts',
  templateUrl: 'network-contacts.html',
})
export class NetworkContacts {

  client: any;
  event: any;
  myProfiles: any = [];
  items: any;
  textTranslate: any;

  constructor(public navCtrl: NavController, public params: NavParams, public userProvider: UserData, public auth: AuthData, public alertCtrl: AlertController, translate: Translate, public loadingCtrl: LoadingController, public db: Database, public toastCtrl: ToastController, public eventProvider: EventData) {
    translate.translateGroup(['¿Está seguro que desea aprobar la solicitud de contacto?', 'Cancelar', 'Continuar', 'Se ha realizado el match correctamente'])
    .then(result => {
      this.textTranslate = result;
    });

    this.client = this.params.get('client');
    this.event = this.params.get('event');

    this.eventProvider.getMyContacts(this.client, this.auth.getUser().uid).subscribe((result: any) => {
      console.log(result)
      if (result) {
        this.myProfiles = result;
      } else {
        this.myProfiles = [];
      }

      this.initializeItems();
    });
  }

  initializeItems() {
    this.items = this.myProfiles;
  }

  getItems(ev: any) {
    this.initializeItems();

    let val = ev.target.value;

    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (item.networkingData.search.toLowerCase().indexOf(val.toLowerCase()) > -1);
      });
    }
  }

  optionProfile(profile) {
    if (profile.networkingData.stateNetworking == 'pending') {
      this.match(profile);
    } else {
      this.viewProfile(profile);
    }
  }

  match(profile) {
    let loading = this.loadingCtrl.create();

    let alert = this.alertCtrl.create({
      title: this.event.title,
      message: this.textTranslate['¿Está seguro que desea aprobar la solicitud de contacto?'],
      buttons: [
        {
          text: this.textTranslate['Cancelar'],
          role: 'cancel',
          handler: data => {}
        },
        {
          text: this.textTranslate['Continuar'],
          handler: data => {
            loading.present();
            this.db.updateData('/Clients/' + this.client.url + '/___NetworkingUsers/' + this.auth.getUser().uid + '/' + profile.id + '/networkingData/stateNetworking', 'match').then(() => {
              this.db.updateData('/Clients/' + this.client.url + '/___NetworkingUsers/' + profile.id + '/' + this.auth.getUser().uid + '/networkingData/stateNetworking', 'match').then(() => {

                // Return Increase counter user
                firebase.database().ref().child('/Clients/' + this.client.url + '/Users/' + this.auth.getUser().uid + '/numRequestNetworking').
                transaction(function(currentCount) {
                  return currentCount - 1;
                });

                // Increase counter dashboard
                firebase.database().ref().child('/Clients/' + this.client.url + '/___Dashboard/' + this.event.id + '/numMatchNetworking').
                transaction(function(currentCount) {
                  return currentCount + 1;
                });

                let toast = this.toastCtrl.create({
                  message: this.textTranslate['Se ha realizado el match correctamente'],
                  duration:3000
                });
                toast.present();
                loading.dismiss();
                return true;
              });
            });
          }
        }
      ]
    });
    alert. present();
  }

  viewProfile(profile) {
    this.navCtrl.push(NetworkProfilePage, {client: this.client, event: this.event, dataProfile: profile});
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/network-contacts/network-contacts.ts